var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{attrs:{"id":"table-list-page-info-popup","title":_vm.data.title,"active":_vm.showPopup},on:{"update:active":function($event){_vm.showPopup=$event}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.html)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }